// Internal observability of analytics itself.
// Counters and gauges visible via debug mode and window.__analytics_metrics().

interface MetricsState {
  dropped_events_total: number;
  dropped_pre_consent: number;
  dropped_rate_limit: number;
  dropped_kill_switch: number;
  dropped_schema_invalid: number;
  queue_size_current: number;
  offline_queue_size: number;
  provider_failures: Record<string, number>;
  provider_load_ms: Record<string, number>;
  consent_accept_rate: { accepts: number; rejects: number; partials: number };
  events_dispatched_total: number;
  events_buffered_pre_consent: number;
  replay_disabled_reason: string | null;
}

const state: MetricsState = {
  dropped_events_total: 0,
  dropped_pre_consent: 0,
  dropped_rate_limit: 0,
  dropped_kill_switch: 0,
  dropped_schema_invalid: 0,
  queue_size_current: 0,
  offline_queue_size: 0,
  provider_failures: {},
  provider_load_ms: {},
  consent_accept_rate: { accepts: 0, rejects: 0, partials: 0 },
  events_dispatched_total: 0,
  events_buffered_pre_consent: 0,
  replay_disabled_reason: "sprint_3_pending",
};

export const metrics = {
  inc(key: keyof MetricsState, by = 1): void {
    const v = state[key];
    if (typeof v === "number") (state[key] as number) = v + by;
  },
  setQueueSize(n: number): void {
    state.queue_size_current = n;
  },
  setOfflineSize(n: number): void {
    state.offline_queue_size = n;
  },
  providerFailure(name: string): void {
    state.provider_failures[name] = (state.provider_failures[name] ?? 0) + 1;
  },
  providerLoadMs(name: string, ms: number): void {
    state.provider_load_ms[name] = ms;
  },
  consentDecision(kind: "accepts" | "rejects" | "partials"): void {
    state.consent_accept_rate[kind] += 1;
  },
  setReplayDisabledReason(r: string | null): void {
    state.replay_disabled_reason = r;
  },
  snapshot(): Readonly<MetricsState> {
    return { ...state, provider_failures: { ...state.provider_failures }, provider_load_ms: { ...state.provider_load_ms } };
  },
};

if (typeof window !== "undefined") {
  (window as unknown as { __analytics_metrics?: () => Readonly<MetricsState> }).__analytics_metrics = () => metrics.snapshot();
}
